



angular.module('SpidApp')

.factory('YearStockChartGenerator', ['StockChartUtils', function (StockChartUtils) {
    var YearStockChartGenerator = function (stockflows, when) {
        stockflows = stockflows || []
        
        var stockflowsOrderedByMonth = _.chain(stockflows).groupBy(function (stockflow) {
            return moment(stockflow.updated_at).format('MM/YYYY') // TODO: bad locale flow
        }).mapObject(function (stockflows) {
            var res = 0
            
            if (stockflows.length > 0) {
                res = stockflows[0].current
            }
            
            return res
        }).value()
        
        var labels = []
        var values = []
        
        var startOfYear = moment(when)
        startOfYear.set('date', 1)
        startOfYear.set('month', 0)
        
        var endOfYear = moment(when)
        endOfYear.set('date', 31)
        endOfYear.set('month', 11)
        
        var curseur = moment(endOfYear)
        
        for(var i = 0 ; i < 12 ; i++) {
            var key = curseur.format('MM/YYYY')
            
            labels.push(key)
            values[i] = stockflowsOrderedByMonth[key] || null
            
            curseur.subtract(1, 'month')
        }
        labels = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
        values = values.reverse()
        
        this.series = ['Flux du produit']
        this.labels = labels
        this.data = [ StockChartUtils.continuousDistribution( values ) ]
        this.options = {
              animation            : true
            , showTooltips         : true
            , showScale            : true
            , scaleBeginAtZero     : true
            , showGridLines        : false
        }
        this.colours = [{
              fillColor   : '#FFE7A0'
            , strokeColor : '#FFC928'
        }]
    }
        
    YearStockChartGenerator.prototype.get = function () {
        return {
              series     : this.series
            , labels     : this.labels
            , data       : this.data
            , options    : this.options
            , colours    : this.colours
        }
    }
    
    return YearStockChartGenerator
}])
